import * as React from "react";
const IconBasket = (props) => (
  <svg
    width={props.size || "48"}
    height={props.size || "48"}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.9986 6C14.9986 7.06087 14.5772 8.07828 13.827 8.82843C13.0769 9.57857 12.0595 10 10.9986 10C9.93775 10 8.92033 9.57857 8.17018 8.82843C7.42004 8.07828 6.99861 7.06087 6.99861 6M2.63183 5.40138L1.93183 13.8014C1.78145 15.6059 1.70626 16.5082 2.0113 17.2042C2.2793 17.8157 2.74364 18.3204 3.3308 18.6382C3.99908 19 4.90447 19 6.71525 19H15.282C17.0928 19 17.9981 19 18.6664 18.6382C19.2536 18.3204 19.7179 17.8157 19.9859 17.2042C20.291 16.5082 20.2158 15.6059 20.0654 13.8014L19.3654 5.40138C19.236 3.84875 19.1713 3.07243 18.8275 2.48486C18.5247 1.96744 18.0739 1.5526 17.5331 1.29385C16.919 1 16.14 1 14.582 1L7.41525 1C5.85724 1 5.07823 1 4.46413 1.29384C3.92336 1.5526 3.47251 1.96744 3.16974 2.48486C2.82591 3.07243 2.76122 3.84875 2.63183 5.40138Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconBasket;
